<template lang="pug">

tr

    //- Name
    td: router-link(v-bind:to='{ name: "persons/update", params: { id: personModel.id } }') {{ fullName }}

    //- Unternehmen
    td: router-link(v-bind:to='{ name: "companies/update", params: { id: companyModel.id } }') {{ companyModel.name }}

    //- E-Mail
    td {{ personModel.email }}

</template>

<script>
    import * as R from 'ramda'
    import { full_name } from '@/utils/person'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            companyModel() {
                return R.find(R.propEq('id', this.personModel.company), this.companyModels)
            },

            fullName() {
                return full_name(this.personModel)
            }

        },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            personModel: {
                type: Object,
                required: true
            },
            
        }

    }

</script>
